<script>
import { useReservationStore } from '../../../store/contact/ReservationStore';

export default {
    setup() {
        const store = useReservationStore();
        const { nextStep, prevStep } = store;
        return {
            nextStep,
            prevStep,
        };
    },
};
</script>
<template>
    <div class="row">
        <div class="col-12 col-lg-3 order-lg-2 offset-lg-6 buttons-wrapper">
            <div class="prev-button" @click="prevStep">
                <i aria-hidden="true" class="fa fa-chevron-left fw-bold"></i>
            </div>
            <div class="next-button" @click="nextStep">
                Next
                <i aria-hidden="true" class="fa fa-chevron-right fw-bold"></i>
            </div>
        </div>
        <div
            class="col-12 col-lg-3 order-lg-1 back-button-wrapper mt-40px mt-0px-lg"
        >
            <a
                href="/contact-us"
                class="fs-14px fw-semibold tw-text-accentGreen hover:tw-text-accentGreen"
            >
                BACK TO START
            </a>
        </div>
    </div>
</template>
